import React, { useState, useEffect, useRef} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, GpsBaseURL, uniqueToken, Role } from '../../api/DataApis';

import { Link, Navigate, useParams, useLocation } from 'react-router-dom';
import request from '../../Apis/request';
import "./User.css";
import ReactPaginate from 'react-paginate'; 
import { GrTransaction } from 'react-icons/gr';
import Loader from '../Settings/Loader';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { Title } from 'chart.js';
import { createRoot } from "react-dom/client";



  const Users = () => {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [Users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(null);
  const [cities, setcities] = useState([]);
  const [selectedcity, setSelectedcity] = useState("");
  const [SelectedState, setSelectedState] = useState("");
  const [searchTerm, setSearchTerm] = useState('');
  const [userStatuses, setUserStatuses] = useState({});
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); 
  const [selectedUser, setSelectedUser] = useState('');
  const [popupInput, setPopupInput] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [Limit, setLimit] = useState({});
  const [currentPage, setCurrentPage] = useState(1); 
  const [selectStatusType, setselectedStatusType] = useState("");
  const [file, setFile] = useState(null); // State to hold the selected file
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [UserID, setUserID] =  useState([]);
  const [selectEmail, setSelectEmail] = useState("");
  const [Loaders, setLoaders] =  useState(false);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [title, setTitle] =  useState("");
  const [Comment, SetComment] =  useState("");
  const [ProductData, setProductData] =  useState([]);
  const [CorporateData, setCorporateData] = useState([]);
  const [selectedCorporate, setSelectedCorporate] = useState("");
  const [hasFetched, setHasFetched] = useState(false);
  const [EmailStatus, setEmailStatus] =  useState("");
  const [ExcelUploadedBy, setExcelUploadedBy] =  useState("");

  


 
   let params = useParams();
   let location = useLocation();
   let userViewData = location?.state?.UserViewData;
    let ImportredID = location?.state?.ImportedID;
    let CorporateID = location?.state?.CoporateID;

  
    
 

    const fetchCorporate = async () => {
     let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/corporate`);
     try {
        const response = await axios.get(apiEndpoint, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
          },
        });
    setCorporateData(response.data?.data);
      // Assuming API returns totalCount for pagination
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        //setLoadings(false);
      }
    };
    
    // Re-fetch users whenever searchTerm changes
    useEffect(() => {
      if (Role === "false") {
        fetchCorporate();  // Only fetch corporate data if Role === "false"
      }
    }, [Role]);
    const fetchProduct = async (page) => {
      let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/product/get/list?status=Active`);
    if (CorporateID) {
     apiEndpoint = decodeURIComponent(`${GpsBaseURL}/product/get/list?status=Active&corporate_id=${CorporateID}`);
     }
    try {
        const response = await axios.get(apiEndpoint, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
          },
        });
    
        console.log("response", response);
    
        setProductData(response.data);
      // Assuming API returns totalCount for pagination
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        //setLoadings(false);
      }
    };
    
    // Re-fetch users whenever searchTerm changes
    useEffect(() => {
      fetchProduct();
    }, []);

  const handleUserID = (userID) => {
    setUserID((prevUserIDs) => {
      if (prevUserIDs.includes(userID)) {
        // If user is already selected, deselect them
        return prevUserIDs.filter((id) => id !== userID);
      } else {
        // If user is not selected, select them
        return [...prevUserIDs, userID];
      }
    });
  };

  const handleSelectAll = () => {
    if (isSelectAllChecked) {
      // If "Select All" is checked, deselect all
      setUserID([]);
    } else {
      // If "Select All" is not checked, select all users
      const allUserIDs = Users.map((user) => user._id); // Assuming users is an array of user objects with _id
      setUserID([...UserID, ...allUserIDs]);
    }
    setIsSelectAllChecked(!isSelectAllChecked); // Toggle "Select All" checkbox state
  };

  useEffect(() => {
    // If all users are selected, check the "Select All" checkbox
    setIsSelectAllChecked(Users.length > 0 && UserID.length === Users.length);
  }, [UserID, Users]);

const handleEmailStatusChange = (e) => {
  setEmailStatus(e.target.value);
}
const handleFilterUploadedBy = (e) => {
  setExcelUploadedBy(e.target.value);
}
 
const handlesendEmailChange = async (e) => {
     
  const value = e.target.value;
  let selectedProduct = null; // Declare outside to maintain value

  if (value) {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to send an email?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: `<span id="swal-confirm-text">Yes, Send it!</span>`,
        cancelButtonText: "No, cancel!",
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        preConfirm: async () => {
          try {
            // **Show Loader in Button**
            Swal.getConfirmButton().innerHTML = `<i class="fa fa-spinner fa-spin"></i> Sending...`;
            Swal.getConfirmButton().disabled = true;

            const title = document.getElementById("titleInput").value;
            const comment = document.getElementById("commentInput").value;
            const sendOption = document.querySelector('input[name="sendOption"]:checked').value;

            if (!title || !comment) {
              Swal.showValidationMessage("Please provide both title and comment");
              return false;
            }

            const response = await fetch(`${GpsBaseURL}/user/send-email`, {
              method: "POST",
              headers: {
                Authorization: `Bearer ${uniqueToken}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                userIds: UserID,
                title,
                comment,
                product_id: selectedProduct,
                type: sendOption,
              }),
            });

            const data = await response.json();

            // **Restore Button**
            Swal.getConfirmButton().innerHTML = `Yes, Send it!`;
            Swal.getConfirmButton().disabled = false;

            if (response.status === 200) {
              Swal.fire({
                icon: "success",
                title: "Success!",
                text: data.message,
                showConfirmButton: true,
              }).then(() => {
                navigate("/email-processing-logs"); // ✅ Navigate after success message
              });
            } else {
              throw new Error(data.message || "Failed to send email");
            }
          } catch (error) {
            console.error("Error during request:", error);
            Swal.showValidationMessage("Failed to send email. Please try again.");
            Swal.getConfirmButton().innerHTML = `Yes, Send it!`;
            Swal.getConfirmButton().disabled = false;
          }
        },
        html: `
          <div id="select-product-container" style="margin-bottom: 10px;"></div>

          <div style="display: flex; flex-direction: column; align-items: flex-start;">
            <label for="titleInput" style="font-weight: bold; text-align: left; width: 100%;">Title</label>
            <input id="titleInput" class="form-control" placeholder="Enter Title" 
                  style="width: 100%; padding: 8px; margin-top: 5px; border-radius: 5px; border: 1px solid #ccc; text-align: left;">
            
            <label for="commentInput" style="margin-top: 10px; font-weight: bold; text-align: left; width: 100%;">Comment</label>
            <textarea id="commentInput" class="form-control" placeholder="Enter Your Comment" 
                      style="width: 100%; padding: 8px; margin-top: 5px; border-radius: 5px; border: 1px solid #ccc; height: 85px; text-align: left;"></textarea>
          </div>

          <div style="margin-top: 15px; display: flex; flex-direction: column; align-items: flex-start;">
              <label style="display: flex; align-items: center; gap: 5px; text-align: left;">
                  <input type="radio" name="sendOption" value="send_all_user" id="sendAll">
                  Send to All Users
              </label>
              <label style="display: flex; align-items: center; gap: 5px; text-align: left; margin-top: 5px;">
                  <input type="radio" name="sendOption" value="selected_users" id="sendSelected" checked>
                  Send to Selected Users
              </label>
          </div>
        `,
        didOpen: () => {
          const container = document.getElementById("select-product-container");
          if (container) {
            const root = createRoot(container);
            root.render(
              <Select
                options={ProductData.map((item) => ({
                  value: item._id,
                  label: item.title,
                }))}
                onChange={(option) => {
                  selectedProduct = option ? option.value : null;
                }}
                placeholder="Select Product"
                isClearable
                styles={{
                  control: (base) => ({
                    ...base,
                    width: "100%",
                    height: "38px",
                    fontSize: "14px",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    textAlign: "left",
                  }),
                  menu: (base) => ({
                    ...base,
                    textAlign: "left",
                  }),
                  option: (base) => ({
                    ...base,
                    textAlign: "left",
                    fontSize: "14px",
                  }),
                }}
              />
            );
          }
        },
      });
    } catch (error) {
      console.error("Error during request:", error);
      Swal.fire({
        icon: "error",
        title: "Request Failed",
        text: "An error occurred. Please try again later.",
      });
    }
  }
};

  
  // **Add Loader Styles**
  const style = document.createElement("style");
  style.innerHTML = `
    .swal-loader {
      border: 3px solid white;
      border-top: 3px solid transparent;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
      animation: spin 0.8s linear infinite;
    }
  
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);
  
  
  
  console.log("UserID", UserID);
  const fileInputRef = useRef(null);
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    console.log('Selected file:', file);
    setFile(file); // Store the file in state
  
    if (file) {
      const formData = new FormData();
      formData.append('file', file); // 'file' should match the backend field name
      try {

        const confirmation = await Swal.fire({
          title: 'Are you sure?',
          text: "Do you want to Send Email?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, send!',
          cancelButtonText: 'No, cancel!',
          html: `
            <input id="titleInput" class="swal2-input" placeholder="Enter Title" style="width: 100%; max-width: 300px; margin-top: 10px;">
            <textarea id="commentInput" class="swal2-input" placeholder="Enter Your Comment" style="width: 100%; max-width: 300px; margin-top: 10px;"></textarea>
          `,
          preConfirm: () => {
            const title = document.getElementById('titleInput').value;
            const comment = document.getElementById('commentInput').value;
            
            if (!title || !comment) {
              Swal.showValidationMessage('Please provide both title and comment');
              return false;
            }
            return { title, comment };
          }
        }).then((result) => {
          if (result.isConfirmed) {
            console.log('Title:', result.value.title);
            console.log('Comment:', result.value.comment);
            // Add further logic to handle title and comment
          }
        });
        
        if (confirmation.isConfirmed) {
          const response = await fetch(`${GpsBaseURL}/excel/import-excel`, {
            method: 'POST',
            body: formData,
            headers: {
              Authorization: `Bearer ${uniqueToken}`,
              // 'Content-Type' is automatically set when using FormData
            },
          });
  
          const data = await response.json();
          setIsLoading(false);
          if (response.status === 200) {
            Swal.fire({
              icon: 'success',
              title: 'Success!',
              text: data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            setIsLoading(false);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: data.message,
            });
          }
        } else {
          Swal.fire({
            icon: 'info',
            title: 'Cancelled',
            text: 'Your file upload has been cancelled.',
            showConfirmButton: false,
            timer: 1500,
          });
        }
      } catch (error) {
        setIsLoading(false);
        console.error('Error during file upload:', error);
        Swal.fire({
          icon: 'error',
          title: 'Upload Failed',
          text: 'An error occurred during file upload. Please try again later.',
        });
      }  setIsLoading(true);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Reset the input value
    }
  };
  const [searchTerms, setSearchTerms] = useState({
    srNo: '',
    name: '',
    email: '',
    phone: '',
    meterTransactions: '',
    rfids: '',
    wallet: '',
    status: '',
    createdDate: '',
    actions: '',
    last_email_sent: "",
    createdType : "",
    corporate_name : "",
  });

  let navigate = useNavigate();
  const handleSearch = (column, value) => {
    setSearchTerms((prev) => ({
      ...prev,
      [column]: value
    }));
  };

  const handleReset = (event) => {
    event.preventDefault()
    if(ImportredID) {
      navigate(`/usermanagement/users/${ImportredID}`);
    }
    if (CorporateID) {
      navigate(`/usermanagement/users/${CorporateID}`);
    }
    else {
   navigate(`/usermanagement/users`);
    }
    }
 

  const dataWithSerialNumbers = filteredData.map((user, index) => ({
    ...user,
    serialNumber: (page - 1) * Limit + index + 1, // Calculate and add serial number as a property
  }));
  
  const displayedData = dataWithSerialNumbers.filter((user) => {
    return Object.entries(searchTerms).every(([key, value]) => {
      if (value === '') return true; // Skip empty search terms
      const userValue = user[key];
      if (userValue == null) return false; // Skip if user property doesn't exist
      return userValue.toString().toLowerCase().includes(value.toLowerCase());
    });
  });
  
  
  document.title = "Users";

  const countryOptions = countries.map(country => ({
    value: country.id,
    label: country.name,
    _id: country._id,
  }));

  const stateOptions = states.map((state) => ({
    value: state.id,
    label: state.name,
    _id: state._id
  }));

  const cityOptions = cities.map((city) => ({
    value: city._id,
    label: city.name,
  }));

  
const handleselectedStatusType = (e) => {
  setselectedStatusType(e.target.value);

}
const handleCountryChange = (selectedOption) => {
  console.log("selectedddoption",selectedOption);
  setPage(1);
  // If no option is selected, reset selected country and state
  if (!selectedOption) {
    setSelectedCountry("");
    setSelectedState("");
  } else {
    // Update selectedCountry with the chosen option
    setSelectedCountry({ _id: selectedOption._id, id: selectedOption.value });
    setSelectedState(""); // Reset state when a new country is selected
  }
};


  
const handleStateChange = (selectedOption) => {
  setPage(1);
  if (selectedOption) {

    setSelectedState({ _id: selectedOption._id, id: selectedOption.value });
  } else {
 
    setSelectedState("");
  }
};


const handleCityChange = (selectedOption) => {
  setPage(1);
  setSelectedcity(selectedOption ? selectedOption.value : "");
};

const handlecorporateChange = (selectedOption) => {
  console.log("selectedOption:", selectedOption);
  
  if (selectedOption) {
    setSelectedCorporate({ id: selectedOption._id });
  } else {
    setSelectedCorporate(null); // Reset state when cleared
  }
};


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    const fetchCountriesData = async () => {
  
      const apiEndpoint = `${GpsBaseURL}/settings/countries`;
      try {
        const response = await axios.get(apiEndpoint, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("Countries response", response);
        setCountries(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      } finally {

      }
    };

    fetchCountriesData();
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      if (!selectedCountry) return;
     
      try {
        const response = await axios.get(`${GpsBaseURL}/settings/states/${selectedCountry?.id}`, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("States response", response);
        setStates(response?.data?.data?.data);
      } catch (error) {
        console.error("Error fetching states:", error);
      } finally {
      
      }
    };

    fetchStates();
  }, [selectedCountry]);

  useEffect(() => {
    const fetchCities = async () => {
      if (!SelectedState) return;
      //setLoading(true);
      try {
        const response = await axios.get(`${GpsBaseURL}/settings/cities/${SelectedState?.id}`, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("Cities response", response);
        setcities(response?.data?.data?.data);
      } catch (error) {
        console.error("Error fetching cities:", error);
      } finally {
        //setLoading(false);
      }
    };

    fetchCities();
  }, [SelectedState]);

  const fetchUsers = async (page) => {
    setLoadings(true);
    setHasFetched(false); // 
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/user?`);
    if (ImportredID) {
      apiEndpoint = decodeURIComponent(`${GpsBaseURL}/user?excel_import_id=${ImportredID}`);
    }

    if (CorporateID) {
      apiEndpoint = decodeURIComponent(`${GpsBaseURL}/user?corporate_id=${CorporateID}`);
    }
   
    
    // Prepare query parameters
    const queryParams = [`page=${page}`];
    
    // Add search term to the query params if it's not empty
    // if (searchTerm) queryParams.push(`searchText=${searchTerm}`);
    if (selectedCountry) queryParams.push(`country_id=${selectedCountry?._id}`);
    if (SelectedState) queryParams.push(`state_id=${SelectedState?._id}`);
    if (selectedcity) queryParams.push(`city_id=${selectedcity}`);
    if (searchQuery) queryParams.push(`searchText=${searchQuery}`);
    if (selectStatusType) queryParams.push(`status=${selectStatusType}`);
    if(selectedCorporate?.id) queryParams.push(`corporate_id=${selectedCorporate?.id}`);
    if(EmailStatus) queryParams.push(`is_email_sent=${EmailStatus}`);
    if(ExcelUploadedBy) queryParams.push(`createdType=${ExcelUploadedBy}`);
    
    
    const apiUrl = `${apiEndpoint}&${queryParams.join('&')}`;
  
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      });
  
      console.log("response", response);
      setUsers(response.data.data || []);
      setFilteredData(response.data.data); 
      setTotalCount(response.data.totalCount || 0);
      setLimit(response?.data?.limit);
      setPageCount(Math.ceil(response.data.totalCount / response?.data?.limit)); // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadings(false);
      setHasFetched(true);
    }
  };
  
  // Re-fetch users whenever searchTerm changes
  useEffect(() => {
    fetchUsers(page);
  }, [searchTerm, selectedCountry, SelectedState, selectedcity, page]);
  


  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };
  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  
 
  
  const handleStatusType = async (event, userId, ) => {
    const status = event.target.value;
  
    setUserStatuses(prevStatuses => ({
      ...prevStatuses,
      [userId]: status
    }));
  
    const url = `${GpsBaseURL}/user/change-status/${userId}`;
    //http://localhost:5000/api/admin/user/change-status/66bd306c0b2f0e2ff46a7fde
    
    const formData = new FormData();
    // formData.append("status", status);
  
    try {
      Swal.fire({
        title: 'Processing...',
        text: 'please wait...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const response = await axios.put(url,
        
        {"status" : status}, {
        headers: {
          "Content-Type": "Application/json",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
  
      if (response.data.statusCode === 200) {
        Swal.close();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.message, 
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.close();
        console.log("Failed to update status", response.data);
      }
    } catch (error) {
      Swal.close();
      console.error("Error updating status:", error);
    }
  };
   const handleSearchTextChange = (e) => {
  setSearchQuery(e.target.value);
};

// Handle submit to fetch filtered data
const handleSearchSubmit = async (e) => {
  e.preventDefault(); // Prevent default form submission

  const page = 1; // Always reset to page 1 when searching
  setPage(page); // Ensure pagination resets to the first page

  // Set loading to true while fetching
  setLoadings(true); 

  // Prepare the base URL and query parameters
  let url = `${GpsBaseURL}/user?page=${page}`;
  if (ImportredID) {
    url = decodeURIComponent(`${GpsBaseURL}/user?excel_import_id=${ImportredID}&page=${page}`);
  }
  if (CorporateID) {
    url = decodeURIComponent(`${GpsBaseURL}/user?excel_import_id=${ImportredID}&page=${page}`);
  }
  const params = [];

  // Add search term if present
  if (searchQuery.trim()) {
      params.push(`searchText=${searchQuery}`);
  }
  if (selectStatusType) {
    params.push(`status=${selectStatusType}`);
}

  // Add selected country, state, and city to the params
  if (selectedCountry?._id) {
      params.push(`country_id=${selectedCountry._id}`);
  }
  if (SelectedState?._id) {
      params.push(`state_id=${SelectedState._id}`);
  }
  if (selectedcity) {
      params.push(`city_id=${selectedcity}`);
  }
  if(ExcelUploadedBy) params.push(`createdType=${ExcelUploadedBy}`);
if(selectedCorporate?.id) {
  params.push(`corporate_id=${selectedCorporate?.id}`);
}
if(EmailStatus)
  params.push(`is_email_sent=${EmailStatus}`);
  // Append query parameters to the URL
  if (params.length) {
      url += `&${params.join('&')}`;
  }

  try {
      const res = await axios.get(url, {
          headers: {
              Authorization: `Bearer ${uniqueToken}`, // Include authorization token
          },
      });

      if (res && res?.data && res?.data?.data) {
          setFilteredData(res?.data?.data); // Update filtered data
          setTotalCount(res?.data?.data?.length); // Set total count based on the filtered data length
          setPageCount(Math.ceil(res?.data?.totalCount / Limit)); // Update page count based on results
      } else {
          setFilteredData([]); // If no data is returned, set filtered data to empty
          setTotalCount(0); // If no data is returned, set totalCount to 0
      }
      
  } catch (error) {
      console.error("Error fetching filtered data:", error);
  } finally {
      setLoadings(false); // Set loading to false after fetching
  }
};


const handleButtonClick = () => {
  fileInputRef.current.click(); // Trigger the hidden file input click
};

const corporateOptions = CorporateData?.map(corporate => ({
  value: corporate._id,
  label: `${corporate.corporate_name} (${corporate?.email})`,
  _id: corporate._id,
}));
 console.log("selectedCorporate", selectedCorporate);
  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  <div className="d-flex align-items-center">
    <h4 className="mb-0 me-3">Users({totalCount ? totalCount : "Loading..." })</h4> {/* Add margin to the right of the heading */}
   
  </div>
  <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '20px' }}>
<input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }} // Hide the actual file input
          onChange={handleFileChange}
        />
  <Link
    className="btn btn-transparent grey-salsa btn-outline btn-sm"
    style={{
      border: "1px solid black",
      borderRadius: "34px",
      display: "inline-flex",
      alignItems: "center",
      overflow: "hidden",
      marginLeft: '10px' // Optional spacing between buttons
    }}
    to="/usermanagement/users/add"
  >
    <i className="fa fa-plus"></i> Add Users
  </Link>
</div>

</div>
<hr style={{ marginTop: "0px" }} />
<div className="row">
  <form className="form-horizontal" role="form" style={{ marginTop: "5px" }}>
    <div
      className="row px-3"
      style={{
        display: "flex",
        alignItems: "center",
        //gap: "10px", // Consistent spacing between filters
        flexWrap: "wrap", // Allow wrapping on smaller screens
      }}
    >
<div className="col-md-2 col-sm-12"style={{alignItems: "center"}}>
  <div className="form-group">
    <Select
      options={countryOptions}
      onChange={handleCountryChange}
      value={countryOptions.find(option => option.value === selectedCountry.id) || null}
      placeholder="Country"
      isClearable
    
      styles={{
        control: (base) => ({
          ...base,
          height: '38px', 
          width: '100%', // Make width responsive
          boxShadow: 'none',
          minWidth: '0', // Ensures it can shrink below 165px if needed
          flex: 1, // Allow select to grow and shrink
        }),
      }}
    />
  </div>
</div>

<div className="col-md-2 col-sm-12"style={{display: "flex", alignItems: "center"}}>
  <div className="form-group">
    <Select
      options={stateOptions}
      onChange={(selectedOption) => {
        if (selectedOption) {
          setSelectedState({ _id: selectedOption._id, id: selectedOption.value });
        } else {
          setSelectedState(""); // Clear selection if option is cleared
        }
      }}
      placeholder="State"
      isClearable
  
      styles={{
        control: (base) => ({
          ...base,
          height: '38px',
          width: '100%', // Make width responsive
          minWidth: '150px',
          flex : 1
        }),
      }}
    />
  </div>
</div>
<div className="col-md-2 col-sm-12">
        <div className="form-group">
          <Select
            value={cityOptions.find((option) => option.value === selectedcity) || null}
            onChange={handleCityChange}
            options={cityOptions}
            placeholder="City"
            isClearable
            styles={{
              control: (base) => ({
                ...base,
                height: '38px',
                width: '100%', // Make width responsive
                boxShadow: 'none',
                minWidth: '150px', // Ensures it can shrink below 150px if needed
                flex: 1, // Allow select to grow and shrink
              }),
            }}
          />
        </div>
      </div>

      <div className="col-md-2 col-sm-12">
  <div className="form-group">
    <select
      value={selectStatusType} // Bind the dropdown's value to the state
      onChange={handleselectedStatusType} // Update state on selection change
      className="form-control select2 select2-offscreen"
      style={{
        height: "38px", // Consistent height
        width: '100%', // Make width responsive
      }}
    >
      <option value="">Select Status</option>
      <option value="Active">Active</option>
      <option value="InActive">Inactive</option>
      <option value="Deleted">Deleted</option>
    </select>
  </div>
</div>
{Role === "false" && (
<div className="col-md-2 col-sm-12">
<div className="form-group">
<Select
  options={corporateOptions}
  onChange={handlecorporateChange}
  value={selectedCorporate ? corporateOptions?.find(option => option.value === selectedCorporate.id) : "" || null}
  placeholder="Select Corporate"
  isClearable
  styles={{
    control: (base) => ({
      ...base,
      height: '38px', 
      width: '100%',
      boxShadow: 'none',
      minWidth: '0',
      flex: 1,
    }),
  }}
/>

  </div>
</div>
)}
{ UserID[0]  &&   (
  <>
<div className="col-md-2 col-sm-12">
  <div className="form-group">
    <select
     // Bind the dropdown's value to the state
      onChange={handlesendEmailChange} // Update state on selection change
      className="form-control select2 select2-offscreen"
      style={{
        height: "38px", // Consistent height
        width: '100%', // Make width responsive
      }}
    >
      <option value="">Send Email</option>
      <option value="email">Email</option>
     </select>
  </div>
</div>
</>
)}
<div className="col-md-2 col-sm-12">
  <div className="form-group">
    <select
     // Bind the dropdown's value to the state
      onChange={handleEmailStatusChange} // Update state on selection change
      className="form-control select2 select2-offscreen"
      style={{
        height: "38px", // Consistent height
        width: '100%', // Make width responsive
      }}
    >
      <option value="">Select Email Status</option>
      <option value="Yes" style={{ color: "green" }}>Users (email sent)</option>
      <option value="No" style={{ color: "red" }}>Users (email not sent)</option>
     </select>
  </div>
</div>
<div className="col-md-2 col-sm-12">
  <div className="form-group">
    <select
     // Bind the dropdown's value to the state
      onChange={handleFilterUploadedBy} // Update state on selection change
      className="form-control select2 select2-offscreen"
      style={{
        height: "38px", // Consistent height
        width: '100%', // Make width responsive
      }}
    >
      <option value="">Select Excel Uploaded</option>
      <option value="Excel" >Excel</option>
      <option value="Admin">Admin</option>
      <option value="Web">Web</option>
     </select>
  </div>
</div>
<div className="col-md-2 col-sm-12">
  <div className="form-group">
  <input
    placeholder="Find Data Here"
    className="form-control"
    style={{
      //width: "calc(100% - 150px)", // Increased available width for the input box
      borderRadius: "8px",
      padding: "6px 10px",
      marginRight: "10px",
      height: "38px", // Consistent height
    }}
    value={searchQuery}
    onChange={handleSearchTextChange}
  />
  </div>
</div>
<div className="col-md-2 col-sm-12" style={{ display: "flex", alignItems: "center" }}>

    {/* Search Button */}
    <button
      className="btn btn-primary"
      onClick={handleSearchSubmit} // Calls the handleSearchSubmit function
      style={{
        marginLeft: "10px", // Space between the input and button
        height: "38px", // Consistent height
        width: "80px", // Consistent width for the Search button
        display: "flex", // Enable flexbox for centering
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: 0, 
      }}
    >
      Search
    </button>

    {/* Reset Button */}
    <button
      className="btn btn-primary"
      onClick={handleReset} // Calls the handleReset function
      style={{
        marginLeft: "10px", // Space between the buttons
        height: "38px", // Consistent height
        width: "80px", // Slightly smaller width for Reset button
        display: "flex", // Enable flexbox for centering
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: 0, // Ensure no extra padding that could offset centering
      }}
    >
      Reset
    </button>

</div>

    </div>
  </form>
</div>

<div className="card-body" style={{ marginLeft: "-19px" }}>

  {loadings ? (
    <Loader />
  ) : Users.length > 0 ? (
    <>
      <div className="table-responsive">
      
        <table
          className="display dataTable"
          id="advance-1"
          style={{
            tableLayout: 'auto',
            width: '100%',
            borderCollapse: 'collapse',
          }}
        >
       
          <thead style={{"height" : "10px"}}>
            <tr>
            <th style={{ minWidth: '80px' }}>Sr No</th>
            {(CorporateID || Role === "true") && (
              <th style={{ textAlign: "center", minWidth: "100px", padding: "0px" }}>
                <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    onClick={handleSelectAll}
                    checked={isSelectAllChecked}
                    style={{ width: "16px", height: "16px", cursor: "pointer" }}
                  />
                  <span>Select All</span>
                </label>
              </th>
            )}

              
              <th style={{ minWidth: '200px' }}>
                <input
                  type="text"
                  placeholder="Name"
                  onChange={(e) => handleSearch('name', e.target.value)}
                  style={{ padding: '4px', borderRadius: '5px', width: '100%' }}
                />
              </th>
              <th style={{ minWidth: '270px' }}>
                <input
                  type="text"
                  placeholder="Email"
                  onChange={(e) => handleSearch('email', e.target.value)}
                  style={{ padding: '4px', borderRadius: '5px', width: '100%' }}
                />
              </th>
              <th style={{ minWidth: '150px' }}>
                <input
                  type="text"
                  placeholder="Phone"
                  onChange={(e) => handleSearch('phone', e.target.value)}
                  style={{ padding: '4px', borderRadius: '5px', width: '100%' }}
                />
              </th>
              <th style={{ minWidth: '150px' }}>
                <input
                  type="text"
                  placeholder="Address"
                  onChange={(e) => handleSearch('address', e.target.value)}
                  style={{ padding: '4px', borderRadius: '5px', width: '100%' }}
                />
              </th>
              <th style={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <input
                  type="text"
                  placeholder="Status"
                  onChange={(e) => handleSearch('status', e.target.value)}
                  style={{ padding: '4px', borderRadius: '5px', width: '100%' }}
                />
              </th>
              <th style={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <input
                  type="text"
                  placeholder="Last Email sent"
                  onChange={(e) => handleSearch('last_email_sent', e.target.value)}
                  style={{ padding: '4px', borderRadius: '5px', width: '100%' }}
                />
              </th>
              {Role ==="false" && (
              <th style={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <input
                  type="text"
                  placeholder="Corporate Name"
                  onChange={(e) => handleSearch('corporate_name', e.target.value)}
                  style={{ padding: '4px', borderRadius: '5px', width: '100%' }}
                />
              </th>
              )}
              <th style={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <input
                  type="text"
                  placeholder="Created Date"
                  onChange={(e) => handleSearch('createdDate', e.target.value)}
                  style={{ padding: '4px', borderRadius: '5px', width: '100%' }}
                />
               
              </th>
              <th style={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <input
                  type="text"
                  placeholder="Created Type"
                  onChange={(e) => handleSearch('createdType', e.target.value)}
                  style={{ padding: '4px', borderRadius: '5px', width: '100%' }}
                />
               
              </th>
              
              <th style={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <input
                  type="text"
                  placeholder="Created By"
                  onChange={(e) => handleSearch('created By', e.target.value)}
                  style={{ padding: '4px', borderRadius: '5px', width: '100%' }}
                />
              </th>
              <th style={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <input
                  type="text"
                  placeholder="Updated By"
                  onChange={(e) => handleSearch('Updated By', e.target.value)}
                  style={{ padding: '4px', borderRadius: '5px', width: '100%' }}
                />
              </th>
              <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {displayedData?.map((user, index) => (
              <tr key={user._id}>
                <td>{(page - 1) * Limit + index + 1}</td>
                {(CorporateID || Role === "true") && (
                  <td>
                    <input
                      type="checkbox"
                      onClick={() => handleUserID(user._id)}
                      checked={UserID.includes(user._id)}
                      style={{ marginRight: "8px" }}
                    />
                  </td>
                )}
                
                <td>{user?.name}</td>
                <td>{user?.email}</td>
                <td>{user?.mobile}</td>
                <td>{user?.address}</td>
                <td>
                  <select
                    onChange={(e) => handleStatusType(e, user._id)}
                    value={userStatuses[user._id] || user.status}
                    className="custom-select"
                    id="statusType"
                    name="statusType"
                  >
                    <option value="Active">Active</option>
                    <option value="InActive">InActive</option>
                    <option value="Deleted">Deleted</option>
                  </select>
                </td>
                <td style={{ whiteSpace: 'nowrap' }}>{user?.last_email_sent}</td>
                {Role ==="false" && (
                <td style={{ whiteSpace: 'nowrap' }}>{user?.corporate_name}</td>
              )}
                <td style={{ whiteSpace: 'nowrap' }}>{user?.createdAt}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{user?.createdType}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{user?.created_by}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{user?.updated_by}</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <Link to={`/usermanagement/users/edit/${user._id}`} state={{ UserEditData: user }}>
                    <i className="fa fa-edit" title="Edit User"></i>
                  </Link>
                  <Link to={`/usermanagement/users/view/${user._id}`} state={{ UserViewData: user }}>
                    <i className="fa fa-eye" title="View User"></i>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Render Pagination Only If Data Exists */}
      {displayedData.length > 0 && (
        <div className="pagination-container mt-4">
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
            forcePage={page - 1}
          />
        </div>
      )}
    </>
  ) : (
    !loadings && hasFetched && (
      <div className="text-center">
        <h5>No User Data Found</h5>
      </div>
    )
  )}
</div>



 </div>
      </div>
    </div>
  </div>
</div>
  ); 
};

export default Users;
